import { ChangeDetectionStrategy, Component, computed, Input, viewChild } from '@angular/core';
import { type IconDefinition, type IconName } from '@fortawesome/fontawesome-common-types';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';

@Component({
  selector: 'rcp-top-nav-item-overlay',
  template: `
    <div class="overlay-button" [class.active]="overlayIsActive()" [rcpPopover]="content" rcpPopoverVariation="menu">
      @if (!!iconTyped) {
        <fa-icon [icon]="iconTyped" size="lg"></fa-icon>
      } @else if (!!icon) {
        <fa-icon [icon]="['far', icon]" size="lg"></fa-icon>
      }

      @if (!!label) {
        <span class="nav-item-label">
          {{ label }}
        </span>
      }
    </div>

    <ng-template #content>
      <div class="overlay-content">
        <ng-content></ng-content>
      </div>
    </ng-template>
  `,
  styleUrls: ['./top-nav-item-overlay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TopNavItemOverlayComponent {
  @Input() label: string;
  @Input() iconTyped: IconDefinition;
  @Input() icon: IconName;

  readonly popover = viewChild.required(RcpPopoverDirective);

  overlayIsActive = computed(() => this.popover().rcpPopoverIsVisible());

  closeOverlay() {
    this.popover().hide();
  }
}
